import React from "react";
import styles from "./StudentLoanPartner.module.css";
import Image from "next/image";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface LoanPartnerData {
  id: number;
  title_description: TileDescription;
  images: Image[];
}
interface Props {
  data: LoanPartnerData;
}
const StudentLoanPartner: React.FC<Props> = ({ data }) => {
  const { title_description, images } = data;
  return (
    <div className={styles.loanBanner}>
      <div
        className={`container ${styles.containerBox}`}
        style={{ width: "80%" }}
      >
        <h2 className={styles.loanHeader}>{title_description?.title}</h2>
        <p className={styles.loanDescription}>
          {title_description?.description}
        </p>
        <div className={styles.cards}>
          {images?.map((card) => (
            <div className={styles.imageMobile} key={card.id}>
              <Image
                src={card?.url}
                alt={card?.alternativeText}
                title={card?.alternativeText}
                width={150}
                height={64}
                className={styles.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentLoanPartner;
